import React, { PropsWithChildren, useMemo } from 'react';

import { ConfigCatProvider, createConsoleLogger, LogLevel } from 'configcat-react';

import { getEnvConfig } from './config';

const logger = createConsoleLogger(LogLevel.Info);

const FeatureFlagProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const configCatSDKKey = useMemo(() => getEnvConfig().REACT_APP_CONFIG_CAT_SDK_KEY_COMMON || '', []);

  return (
    <ConfigCatProvider sdkKey={configCatSDKKey} options={{ logger }} id="COMMON">
      {children}
    </ConfigCatProvider>
  );
};

export default FeatureFlagProvider;
